import axios from "axios";
import { apiCall } from "@/common/api/ApiResult.model";
import { Investigation } from "./models";
import { SharedState } from "@/common/state";
import { get_entity_familiarities_status } from "@/views/customize/in-motion/exposure-control/data/api";
import { FamiliarityEntityType } from "@/views/customize/in-motion/exposure-control/data/models";
import { groupBy } from "@/fp";
import { SensitivityLevelHelper } from "@/common/models";

export const investigations = {
  list: apiCall<void, Investigation[]>("investigations.get", async () => {
    const res = await axios.get("/investigation");
    return {
      success: true,
      value: res.data,
    };
  }),
  create: apiCall<Omit<Investigation, "id">, string>(
    "investigations.create",
    async (investigation) => {
      const res = await axios.post("/investigation", { ...investigation });
      return {
        success: true,
        value: res.data.id,
      };
    }
  ),

  update: apiCall<Investigation, number>(
    "investigations.update",
    async (investigation) => {
      const res = await axios.put("/investigation", { ...investigation });
      return {
        success: true,
        value: res.status,
      };
    }
  ),

  isExist: apiCall<string, boolean>(
    "investigations.isExist",
    async (id: string) => {
      await axios.get("/investigation?id=" + id);
      return {
        success: true,
        value: true,
      };
    }
  ),
  /**
   * @param id - investigation id
   * */
  remove: apiCall<string, boolean>(
    "investigations.delete",
    async (id: string) => {
      await axios.delete(`/investigation/${id}`);
      return {
        success: true,
        value: true,
      };
    }
  ),
};

export const get_entity_trust_status = async (
  entity_id: string,
  type: FamiliarityEntityType
) => {
  const info_types = SharedState.l0InfoTypes.value
    // .filter((f) => f.code !== 7)
    .map((f) => f.id);
  const to_virtual_label = SharedState.getVirtualLabelByLabelCategory;
  const virtual_labels = info_types
    .map((l0_id: string) => [
      to_virtual_label(l0_id, "High").id,
      to_virtual_label(l0_id, "Medium").id,
      to_virtual_label(l0_id, "Low").id,
      to_virtual_label(l0_id, "None").id,
    ])
    .flat();

  const res = await get_entity_familiarities_status({
    entityId: entity_id,
    labelIds: virtual_labels,
    type: type,
  });

  if (res.success) {
    const status_by_l0 = groupBy(
      "l0",
      res.value
        .map((l) => {
          const v_label = SharedState.indexed_virtualLabels.value[l.labelId];
          return {
            ...l,
            l0: v_label.parentId,
            sensitivity: v_label.sensitivity,
          };
        })
        .sort((a, b) => a.sensitivity - b.sensitivity)
    );
    const familiarities = (info_types as string[]).reduce((acc, id) => {
      const highest_trusted_sensitivity = [
        ...(status_by_l0.get(id) || []),
      ].reduce((acc, item) => {
        if (item.status === "trusted") {
          return Math.max(item.sensitivity, acc);
        }
        return acc;
      }, -1);
      acc[id] =
        highest_trusted_sensitivity > -1
          ? SensitivityLevelHelper.floatToInt(highest_trusted_sensitivity)
          : -1;
      console.log("acc[id]", acc[id]);
      return acc;
    }, {} as { [key: string]: number });
    console.log("familiarities for :", familiarities);
    return familiarities;
  }
};
